import { HttpClient, HttpParams } from "@angular/common/http";
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, Renderer2 } from "@angular/core";
import { Observable } from "rxjs";
import { FeatureModuleService } from "@webapp/feature-toggles/services/feature-module.service";
import { RichTextEditorIconEnum } from "@webapp/shared/rich-text-editor/rich-text-editor-icon/rich-text-editor-icon.enum";
import { GifSize, GifType, IGif, ITenorResponse, SizeOfGif } from "./add-gif.models";

const TENOR_API_KEY = "8S423V0QMWIB";

@Component({
  selector: "add-gif",
  templateUrl: "./add-gif.component.html",
  styleUrls: ["./add-gif.component.less"],
})
export class AddGIFComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() public outOfFocus: boolean;

  @Output() public readonly gifSelected = new EventEmitter<IGif>();
  @Output() public readonly selectorOpen = new EventEmitter<MouseEvent>();
  @Output() public readonly selectorClose = new EventEmitter<MouseEvent>();

  public searchQuery = "";
  public gifs: IGif[];
  public showGifMenu = false;
  public checkinDivId: string;
  public gifIcon = RichTextEditorIconEnum.GIF;
  public isModuleGifsEnabled$: Observable<boolean>;

  private removeClickListener: () => void;

  constructor(
    private elementRef: ElementRef,
    private http: HttpClient,
    private featureModuleService: FeatureModuleService,
    private renderer: Renderer2,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.isModuleGifsEnabled$ = this.featureModuleService.isGifsModuleEnabled$();
  }

  public ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.removeClickListener = this.renderer.listen("document", "click", (event: PointerEvent) => {
        if (!this.elementRef.nativeElement.contains(event?.target)) {
          this.ngZone.run(() => this.closeGifSearchModal(event));
        }
      });
    });
  }

  public ngOnDestroy(): void {
    if (this.removeClickListener) {
      this.removeClickListener();
      this.removeClickListener = null;
    }
  }

  public selectGif(gif: IGif, event: MouseEvent): void {
    gif.searchQuery = this.searchQuery;

    this.gifSelected.emit(gif);

    this.closeGifSearchModal(event);
  }

  public searchGifs(): void {
    this.getGifUrls("search", SizeOfGif.Small, this.searchQuery);
  }

  public toggleGifSearchModal(event?: MouseEvent): void {
    if (this.showGifMenu) {
      this.closeGifSearchModal(event);
    } else {
      this.getGifUrls("trending", SizeOfGif.Small);
      this.openGifSearchModal(event);
    }
  }

  public closeGifSearchModal(event?: MouseEvent): void {
    this.showGifMenu = false;
    this.searchQuery = "";

    this.selectorClose.emit(event);
    this.cdr.detectChanges();
  }

  private openGifSearchModal(event?: MouseEvent): void {
    this.showGifMenu = true;

    this.selectorOpen.emit(event);
  }

  private getGifUrls(gifType: GifType, gifSize: GifSize, searchQuery = ""): void {
    const url = `https://g.tenor.com/v1/${gifType}`;
    let params = new HttpParams();

    params = params.set("key", TENOR_API_KEY);
    params = params.set("media_filter", gifSize);
    params = params.set("limit", 8);

    if (searchQuery) {
      params = params.set("q", searchQuery);
    }

    this.http.get<ITenorResponse>(url, { params }).subscribe(({ results }) => {
      this.ngZone.run(
        () =>
          (this.gifs = results.map(({ id, media }) => ({
            id: id,
            url: media[0]?.[gifSize]?.url,
          })))
      );
    });
  }
}
